"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ColumnChart = require("./ColumnChart");
Object.keys(_ColumnChart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ColumnChart[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ColumnChart[key];
    }
  });
});